__turbopack_context__.v({
  "removeBtn": "Bk3GgG_removeBtn",
  "whiteBtn": "Bk3GgG_whiteBtn",
});
